import { render, staticRenderFns } from "./CustomerUpload.vue?vue&type=template&id=264edc64&scoped=true&"
import script from "./CustomerUpload.vue?vue&type=script&lang=js&"
export * from "./CustomerUpload.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUpload.vue?vue&type=style&index=0&id=264edc64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264edc64",
  null
  
)

export default component.exports